export class SinistreNatureModel{
    cnId: string;
    cnCode: string;
}